module.exports = __webpack_public_path__ + "img/Smartransfer.bb85ad07.png";